import React from 'react';

import { ALL_OPTION } from '@/common/constants';

import { useGetOrganizationsTitleQuery } from '../queries';

import ScheduledFilterItem from './ScheduledFilterItem';

interface Props {
  testId?: string;
  employerId?: string;
  employerIds?: string[];
}
const OrganizationTitle: React.FC<Props> = ({ testId, employerId, employerIds }) => {
  const { isLoading, title } = useGetOrganizationsTitleQuery({
    employerId: employerId,
    employerIds: employerIds,
  });

  return (
    <ScheduledFilterItem
      title="Employer"
      testId={`${testId}_employer-name`}
      isLoading={isLoading}
      text={title || ALL_OPTION.title}
    />
  );
};
export default OrganizationTitle;
